import styled from 'styled-components';
import { MdDelete, MdEdit, MdVisibility } from 'react-icons/md';

export const Container = styled.div`
  padding: 20px;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const HeaderRow = styled.tr`
  background: #f5f5f5;
`;

export const Th = styled.th`
  text-align: left;
  padding: 10px;
  border-bottom: 1px solid #ddd;
  font-size: 13px;
`;

export const Tr = styled.tr`
  &:hover {
    background: #fafafa;
  }
`;

export const Td = styled.td`
  padding: 10px;
  border-bottom: 1px solid #eee;
  font-size: 13px;
`;

export const DeleteIcon = styled(MdDelete).attrs({ size: '19px' })`
  color: #f27160;
  cursor: pointer;
`;

export const EditIcon = styled(MdEdit).attrs({ size: '19px' })`
  color: #122d58;
  cursor: pointer;
`;

export const ViewIcon = styled(MdVisibility).attrs({ size: '19px' })`
  color: #122d58;
  cursor: pointer;
`;

export const WrapperPopover = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const PopoverText = styled.p`
  font-size: 14px;
  font-weight: 600;
  color: #7b7b7b;
  margin-bottom: 15px;
`;

export const PopoverButton = styled.button`
  background-color: ${(props) => (props.primary ? '#122d58' : '#fff')};
  color: ${(props) => (props.primary ? '#fff' : '#122d58')};
  border: 1px solid #122d58;
  border-radius: 5px;
  padding: 8px 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  margin: 0 5px;

  &:hover {
    background-color: ${(props) => (props.primary ? '#0f2447' : '#f5f5f5')};
  }
`;


